<template>
  <BaseCard>
    <BaseCardHeader>
      <div class="flex justify-between items-baseline">
        <div class="capitalize">
          {{ $te('brochure') ? $t('brochure') : 'brochure' }}
        </div>
      </div>
    </BaseCardHeader>
    <BaseCardBody>
      <BaseList nested>
        <BaseListBody>
          <BaseListItem>
            <a v-if="brochure" :href="brochure.url" target="_blank" class="mb-4 block">{{
              brochure.name
            }}</a>
            <div class="flex">
              <FileUpload @file-upload="doUpdateBrochure" class="mx-auto">
                <template #button="{ fileUploadButtonClick }">
                  <button @click="fileUploadButtonClick" class="btn btn-brand">
                    Upload Brochure
                  </button>
                </template>
              </FileUpload>
            </div>
          </BaseListItem>
        </BaseListBody>
      </BaseList>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import FileUpload from '@/components/Ui/FileUpload.vue';
import { productMethods } from '@/store/adminHelper';

export default {
  name: 'Brochure',
  components: {
    FileUpload,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    brochure() {
      const { media = [] } = this.product || {};
      return media.find((item) => item.collection === 'brochures') || null;
    },
  },
  methods: {
    ...productMethods,
    doUpdateBrochure({ config, data, success, error }) {
      const { id: productId } = this.product;
      this.updateProductBrochure({ config, productId, formData: data })
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    },
  },
};
</script>
